import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-2xl mb-5"
}
const _hoisted_2 = {
  key: 1,
  class: "pt-5"
}
const _hoisted_3 = { class: "flex flex-col mb-3" }
const _hoisted_4 = { class: "flex mb-3 gap-3" }
const _hoisted_5 = { class: "basis-1/2" }
const _hoisted_6 = ["min"]
const _hoisted_7 = { class: "basis-1/2" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-end pt-3 items-center"
}
const _hoisted_9 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_10 = {
  key: 2,
  class: "flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.Visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Visible) = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h2", {
          class: _normalizeClass(["text-2xl font-bold", {'text-center mb-5': _ctx.status}])
        }, _toDisplayString(_ctx.Title), 3)
      ]),
      (_ctx.creazione_permission_denied)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            class: "sticky top-0 z-10 bg-next-orange"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Non hai i permessi sufficienti per poter creare un alert")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.modifica_permission_denied)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            class: "sticky top-0 z-10 bg-next-orange"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Non hai i permessi sufficienti per poter aggiornare un alert")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      (_ctx.status === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$filters.toDate(_ctx.alert.scadenza)), 1))
        : (_ctx.status === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "font-bold" }, "Titolo *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alert.descrizione) = $event)),
                  placeholder: "Titolo",
                  class: "col-span-3 p-2 bg-next-gray-md h-36"
                }, null, 512), [
                  [_vModelText, _ctx.alert.descrizione]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getErrors('descrizione'), (e, i) => {
                  return (_openBlock(), _createElementBlock("small", {
                    key: i,
                    class: "text-next-orange"
                  }, _toDisplayString(e), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "font-bold" }, "Seleziona una data *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.alert.scadenza) = $event)),
                    type: "date",
                    min: _ctx.minDate,
                    class: "col-span-3 p-2 bg-next-gray-md w-full"
                  }, null, 8, _hoisted_6), [
                    [_vModelText, _ctx.alert.scadenza]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getErrors('scadenza'), (e, i) => {
                    return (_openBlock(), _createElementBlock("small", {
                      key: i,
                      class: "text-next-orange"
                    }, _toDisplayString(e), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "font-bold" }, "Giorni di preavviso", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.alert.giorni_preavviso) = $event)),
                    type: "number",
                    min: 0,
                    class: "col-span-3 p-2 bg-next-gray-md w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.alert.giorni_preavviso]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getErrors('giorni_preavviso'), (e, i) => {
                    return (_openBlock(), _createElementBlock("small", {
                      key: i,
                      class: "text-next-orange"
                    }, _toDisplayString(e), 1))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (_ctx.status === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.id)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.status = 3)),
                  class: "underline cursor-pointer"
                }, "Elimina"))
              : _createCommentVNode("", true),
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _ctx.chiudi,
              class: "col-start-3 ml-4 py-2 px-4"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" Chiudi ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NextButton, {
              variant: "primary",
              disabled: _ctx.loading_button,
              onClick: _ctx.handleSuccess,
              class: "py-2 px-4 ml-4 flex items-center justify-center"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
                  [_vShow, _ctx.loading_button]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.SuccessButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]))
        : (_ctx.status === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_NextButton, {
                variant: "outline-secondary",
                onClick: _ctx.destroy,
                class: "ml-4 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Conferma ")
                ])),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_NextButton, {
                variant: "primary",
                onClick: _ctx.chiudi,
                class: "ml-4 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" Chiudi ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_NextButton, {
                variant: "primary",
                onClick: _ctx.chiudi,
                class: "ml-4 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" Chiudi ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]))
    ]),
    _: 1
  }, 8, ["visible"]))
}